import { getEmptyConfigByKey, getAllData, getDb } from '../../../../components/utils/indexedDbUtils'

const CONTACT_PLAN_CT = [
  'as_contact_plan',
  'as_service_contact_plan'
]


export default async function updateCampaignSectionCC ({ commit, getters }, payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data, section, vm } = payload

      const { config, flat, userPreferences } = data
      const currentCampaign = getters.currentCampaign

      if (config) {
        // Check if masterkey or brand changed. If so reset offers and filters.
        if (section === 'campaignData') {
          // Check masterkey
          const oldData = currentCampaign.config.campaignData
          const newData = config

          const oldMasterKey = oldData.masterKey.selected
          const newMasterKey = newData.masterKey.selected

          // Check brand
          const oldBrands = oldData.campaignBrands.selected
          const newBrands = newData.campaignBrands.selected

          // Check markets
          const oldMarkets = JSON.stringify(oldData.markets.selected)
          const newMarkets = JSON.stringify(newData.markets.selected)

          if ((JSON.stringify(oldBrands) !== JSON.stringify(newBrands)) || (oldMasterKey && oldMasterKey !== newMasterKey) || oldMarkets !== newMarkets) {
            if (currentCampaign.config.offers) {
              commit('UPDATE_CAMPAIGN_CONFIG_SECTION', { section: 'offers', data: [] })
            }
            if (currentCampaign.config.contents) {
              commit('UPDATE_CAMPAIGN_CONFIG_SECTION', { section: 'contents', data: [] })
            }
            commit('SET_INFORMATIVE_CAMPAIGN', false)
          }
        }

        if (section === 'offers') {
          const oldOffers = currentCampaign.config.offers
          const newOffers = config.offers

          const oldContents = currentCampaign.config.contents
          const newContents = config.contents

          if (JSON.stringify(oldOffers) !== JSON.stringify(newOffers) || (JSON.stringify(oldContents) !== JSON.stringify(newContents))) {
            const configType = currentCampaign.onlyHeader ? 'HEADER' : 'FULL'
            const db = await getDb()
            const [emptyConfig, dealersMap, mvsMap] = await Promise.all([
              getEmptyConfigByKey(configType, db),
              getAllData('clusters', db, (dealers) => dealers.reduce((acc, val) => {
                acc[val.cluster] = val
                return acc
              }, {})),
              getAllData('mvs', db, (mvs) => mvs.reduce((acc, val) => {
                acc[val.mvs] = val
                return acc
              }, {}))
            ])
            commit('UPDATE_CAMPAIGN_CONFIG_SECTION', { section: 'filters', data: {} })
            commit('UPDATE_CURRENT_CAMPAIGN_CONFIG_SECTION', { section: 'filters', data: {} })
            commit('SET_USER_CAN_EDIT_EXCLUDED_VIN', { value: false })

            const mappedFilters = {}
            if (newOffers.length) {
              const progressiveNumbers = {}
              for (let offer of newOffers) {
                console.time(offer.sectionId)
                const { brand } = offer

                const filterObject = _.cloneDeep(emptyConfig.config.filters)
                filterObject.carAges.timeRangeSelector = offer.timeRangeSelector
                filterObject.carAges.range[offer.timeRangeSelector] = offer.range[offer.timeRangeSelector]
                if (!(offer.kmFrom === 0 && offer.kmTo === 0)) {
                  filterObject.mileages.selected = [{ from: offer.kmFrom, to: offer.kmTo }]
                }
                filterObject.fuelTypes.selected = offer.fuelType
                filterObject.engineSize.selected = offer.engineSize
                filterObject.dealerCluster.selected = offer.dealerCluster
                filterObject.segment.selected = offer.segment
                filterObject.modelYearFrom.selected = offer.modelYearFrom
                filterObject.fleet.selected = offer.fleet === '1' ? 'include' : 'noFilter'

                // Add a zip code section for the section market
                filterObject.zipCodes = {
                  selected: {
                    [offer.codMarket]: []
                  }
                }

                const targetClusters = new Set()
                offer.itemsList.forEach(item => {
                  if (item.status) {
                    targetClusters.add(item.status)
                  }
                })

                filterObject.targetCluster.selected = Array.from(targetClusters)

                // Add every MVS from offer
                if (offer.mmvsList.length) {
                  filterObject.mvs.selected = {
                    [offer.brand]: []
                  }
                  filterObject.mvsToExclude.selected = {
                    [offer.brand]: []
                  }
                  offer.mmvsList.forEach(mmvs => {
                    if (mvsMap[mmvs] && (offer.brand === 'All' || filterObject.mvs.selected[mvsMap[mmvs].brand])) {
                      if (!filterObject.mvs.selected[mvsMap[mmvs].brand]) {
                        filterObject.mvs.selected[mvsMap[mmvs].brand] = [mmvs]
                      } else {
                        filterObject.mvs.selected[mvsMap[mmvs].brand].push(mmvs)
                      }
                    }
                  })
                } else {
                  filterObject.mvs.selected = {
                    [offer.brand]: []
                  }
                  filterObject.mvsToExclude.selected = {
                    [offer.brand]: []
                  }
                }

                // Add every VIN from offer
                if (offer.vinList.length) {
                  if (offer.includeOrExcludeVins === 'exclude') {
                    filterObject.vinToExclude.selected = [...new Set(offer.vinList)]
                    commit('SET_USER_CAN_EDIT_EXCLUDED_VIN', { sectionId: offer.sectionId, value: false })
                  } else {
                    filterObject.vin.selected = [...new Set(offer.vinList)]
                    commit('SET_USER_CAN_EDIT_EXCLUDED_VIN', { sectionId: offer.sectionId, value: true })
                  }
                } else {
                  commit('SET_USER_CAN_EDIT_EXCLUDED_VIN', { sectionId: offer.sectionId, value: true })
                }

                // Add every dealer from cluster(s)
                if (filterObject.dealerCluster.selected && filterObject.dealerCluster.selected.length) {
                  filterObject.dealers.selected = {}
                  filterObject.dealerCluster.selected.forEach(dealerCluster => {
                    if (dealersMap[dealerCluster]) {
                      filterObject.dealers.selected[dealerCluster] = [...new Set(dealersMap[dealerCluster].dealers.map(dealer => dealer.idDealer))]
                    }
                  })
                }

                const progressiveNumberKey = `${offer.codMarket}_${offer.brand}`
                if (!progressiveNumbers[progressiveNumberKey]) {
                  progressiveNumbers[progressiveNumberKey] = 1
                } else {
                  progressiveNumbers[progressiveNumberKey] = progressiveNumbers[progressiveNumberKey] + 1
                }
                if (progressiveNumbers[progressiveNumberKey] > 1) {
                  filterObject.sectionTitle = `${vm.$t('markets.' + offer.codMarket)} - ${vm.$t('brands.' + brand)} - ${progressiveNumbers[progressiveNumberKey]}`
                } else {
                  filterObject.sectionTitle = `${vm.$t('markets.' + offer.codMarket)} - ${vm.$t('brands.' + brand)}`
                }
                mappedFilters[offer.sectionId] = filterObject
              }

              commit('UPDATE_CAMPAIGN_CONFIG_SECTION', { section: 'filters', data: mappedFilters })

              commit('UPDATE_CURRENT_CAMPAIGN_CONFIG_SECTION', { section: 'filters', data: mappedFilters })
            } else {
              const filterObject = _.cloneDeep(emptyConfig.config)
              filterObject.filters.mvs.selected = currentCampaign.config.campaignData.campaignBrands.selected.reduce((acc, val) => {
                acc[val] = []
                return acc
              }, {})

              filterObject.filters.zipCodes.selected = currentCampaign.config.campaignData.markets.selected.reduce((acc, val) => {
                acc[val] = []
                return acc
              }, {})

              filterObject.filters.mvsToExclude.selected = _.cloneDeep(filterObject.filters.mvs.selected)
              filterObject.filters.vin.selected = []
              filterObject.filters.vinToExclude.selected = []

              commit('UPDATE_CAMPAIGN_CONFIG_SECTION', { section: 'filters', data: filterObject.filters })
              commit('UPDATE_CURRENT_CAMPAIGN_CONFIG_SECTION', { section: 'filters', data: filterObject.filters })
              commit('SET_USER_CAN_EDIT_EXCLUDED_VIN', { value: true })
            }
          }
        }

        if (section === 'filters') {
          const oldFilters = JSON.stringify(getters.state.currentCampaignConfig.filters)
          const newFilters = JSON.stringify(config)

          if (oldFilters !== newFilters) {
            commit('CLEAR_PREVIEW')
          }

          commit('UPDATE_CURRENT_CAMPAIGN_CONFIG_SECTION', { section: 'filters', data: config })
        }

        commit('UPDATE_CAMPAIGN_CONFIG_SECTION', { section, data: _.cloneDeep(config) })

        // Update VIN and MVS in store config
        if (config.vin) {
          commit('UPDATE_CURRENT_CAMPAIGN_CONFIG_SECTION', { section: 'filters.vin', data: config.vin })
        }
        if (config.mvs) {
          commit('UPDATE_CURRENT_CAMPAIGN_CONFIG_SECTION', { section: 'filters.mvs', data: config.mvs })
        }
        if (config.offers) {
          commit('UPDATE_CAMPAIGN_CONFIG_SECTION', { section: 'offers', data: config.offers })
        }
        if (config.contents) {
          commit('UPDATE_CAMPAIGN_CONFIG_SECTION', { section: 'contents', data: config.contents })
        }
      }

      if (flat) {
        Object.keys(flat).forEach(key => {
          commit('SET_CAMPAIGN_FIELD', { name: key, value: _.cloneDeep(flat[key]) })
        })
      }

      if (userPreferences) {
        Object.keys(userPreferences)
          .forEach(field => {
            commit('SET_USER_PREFERENCE', { name: field, value: _.cloneDeep(userPreferences[field]) })
          })
      }

      resolve()
    } catch (error) {
      reject(error)
    }
  })
}
